import useAdvisorPermissions from "../usePermissions";
import useVatReportsAvailability from "serviceHooks/useVatReportsAvailability";
import { getVatReportsAccess } from "utils/helpers/vatReportsAvailabilityHelper";

/** The advisor permission plus the company's own answer on whether it has VAT reports to show. */
function useVatReportPermissions() {
  const { advisorViewsAvailable } = useAdvisorPermissions();
  // Only an advisor can be answered yes, so nobody else spends a request on asking.
  const availability = useVatReportsAvailability(advisorViewsAvailable);
  const access = getVatReportsAccess(advisorViewsAvailable, availability);

  return { access, vatReportsAvailable: access === "granted", retryAvailability: availability.retry };
}

export default useVatReportPermissions;
